import { render, staticRenderFns } from "./HomeRHProtegidoServices.vue?vue&type=template&id=b159f990&scoped=true&"
import script from "./HomeRHProtegidoServices.vue?vue&type=script&lang=js&"
export * from "./HomeRHProtegidoServices.vue?vue&type=script&lang=js&"
import style0 from "./HomeRHProtegidoServices.vue?vue&type=style&index=0&id=b159f990&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b159f990",
  null
  
)

export default component.exports